/**
 * Canonical purge reasons for player IndexedDB binary cache health (`cachedBinaryAssetPlaybackHealth`).
 * Use these strings in code, logs, and observability (e.g. Sentry) so field issues stay searchable.
 */
export const ASSET_CACHE_PLAYBACK_PURGE_REASON = {
  EMPTY_BODY: 'empty body',
  HTML_OR_JSON_ERROR_UNDER_MEDIA_MIME:
    'body looks like HTML/JSON error while declared as media',
  DECLARED_HTML_BUT_NOT_HTML: 'declared text/html but body does not look like HTML',
  JPEG_CMYK_COLOR_SPACE: 'jpeg cmyk color space not supported'
} as const

export type TAssetCachePlaybackPurgeReason
  = (typeof ASSET_CACHE_PLAYBACK_PURGE_REASON)[keyof typeof ASSET_CACHE_PLAYBACK_PURGE_REASON]
